/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { fontSchema } from "./fontSchema.ts";
import { kioskBannerSchema } from "./kioskBannerSchema.ts";
import { kioskPreloaderSchema } from "./kioskPreloaderSchema.ts";
import { newAppStorySchema } from "./newAppStorySchema.ts";
import { newCartLoyaltyButtonSchema } from "./newCartLoyaltyButtonSchema.ts";
import { newCommentsSchema } from "./newCommentsSchema.ts";
import { newKioskAuthOptionsSchema } from "./newKioskAuthOptionsSchema.ts";
import { newKioskAuthOverlaySchema } from "./newKioskAuthOverlaySchema.ts";
import { newKioskDrumWrfSchema } from "./newKioskDrumWrfSchema.ts";
import { newKioskLoaderScreenSchema } from "./newKioskLoaderScreenSchema.ts";
import { newProductCardDisplaySchema } from "./newProductCardDisplaySchema.ts";

export const newDesignConfigSchema = z.object({
	font: fontSchema,
	kiosk_banners: z.array(kioskBannerSchema),
	kiosk_preloaders: z.array(kioskPreloaderSchema),
	kiosk_preview_preloaders: z.array(kioskPreloaderSchema),
	app_stories: z.array(newAppStorySchema),
	cart_loyalty_button: newCartLoyaltyButtonSchema,
	product_card_display: newProductCardDisplaySchema,
	comments: newCommentsSchema,
	kiosk_auth_overlay: newKioskAuthOverlaySchema,
	kiosk_new_auth_options: newKioskAuthOptionsSchema.nullable().describe("Сериализатор блока выбора способа авторизации на киоске."),
	info_blocks: z.string(),
	hash_sum: z.string(),
	loader_screen: newKioskLoaderScreenSchema,
	logo: z.string().nullable(),
	primary_color: z.string(),
	accent_color: z.string().nullable(),
	accent_light_color: z.string().nullable(),
	accent_dark_color: z.string().nullable(),
	bg_button_color: z.string().nullable(),
	inactive_button_color: z.string().nullable(),
	cards_color: z.string().nullable(),
	text_color: z.string().nullable(),
	nonworking_bg_color: z.string().nullable(),
	fallback_image: z.string().nullable(),
	adult_disclaimer_text: z.string().nullable(),
	adult_disclaimer_image: z.string().nullable(),
	show_badges: z.boolean(),
	max_badges_on_photo: z.int(),
	badge_placement: z.string(),
	badge_shape_default: z.string(),
	use_product_media_in_group_splash: z.boolean(),
	kiosk_banner: z.string().nullable(),
	kiosk_preloader: z.string().nullable(),
	kiosk_preloader_darken: z.boolean(),
	kiosk_night_video: z.string().nullable(),
	kiosk_order_type_selection: z.string(),
	kiosk_order_type_background: z.string().nullable(),
	kiosk_order_type_background_media_type: z.string(),
	kiosk_order_type_background_color: z.string().nullable(),
	main_page_font_family: z.string(),
	apply_custom_size_picker_fonts: z.boolean(),
	size_picker_unselected_font_size: z.number(),
	size_picker_selected_font_size: z.number(),
	show_size_picker_prices: z.boolean(),
	hide_barban: z.boolean(),
	kiosk_infinite_scroll: z.boolean(),
	kiosk_hide_banner: z.boolean(),
	kiosk_proceed_to_payment_text: z.string().nullable(),
	kiosk_timeout: z.int(),
	kiosk_inactivity_timeout: z.int(),
	kiosk_show_loyalty_card_button: z.boolean(),
	kiosk_hide_manual_input_loyalty_card: z.boolean(),
	kiosk_show_loyalty_phone_input_button: z.boolean(),
	kiosk_allow_registration: z.boolean(),
	loyalty_auth_animation: z.string(),
	loyalty_auth_text: z.string(),
	show_nutrition_in_cart: z.boolean(),
	show_nutrition_in_product_card: z.boolean(),
	show_nutrition_per_100g: z.boolean(),
	qr_show_pay_button_ts: z.boolean(),
	qr_show_scan_button: z.boolean(),
	retail_mode: z.boolean(),
	bonuses_button_name: z.string().nullable(),
	pdf_return_url: z.url().nullable(),
	dish_cart_mod_choice_text: z.string().nullable(),
	kiosk_enable_locators: z.boolean(),
	kiosk_required_locator: z.boolean(),
	kiosk_locator_prefix: z.string().nullable(),
	kiosk_enable_wheel: z.boolean(),
	qr_modifiers_design: z.string(),
	kiosk_modifiers_design: z.string(),
	kiosk_new_modifiers_theme: z.string(),
	kiosk_new_modifiers_customize_button_text: z.string(),
	kiosk_new_modifiers_description_title: z.string(),
	kiosk_new_modifiers_disable_customize_button: z.boolean(),
	kiosk_waiting_for_card_payment_screen_text: z.string(),
	kiosk_success_screen_title: z.string(),
	kiosk_success_screen_subtitle: z.string(),
	kiosk_successful_order_screen_background: z.string().nullable(),
	kiosk_successful_order_screen_background_media_type: z.string(),
	kiosk_ask_staff_to_scan_mark_text: z.string(),
	kiosk_create_order_button_text: z.string(),
	delivery_menu_header: z.string(),
	kiosk_enable_categories_ribbon: z.boolean(),
	system_notification_text: z.string().nullable(),
	qr_bypass_guest_auth: z.boolean(),
	kiosk_camera_scan_loyalty_card: z.boolean(),
	kiosk_qr_payment_timeout: z.int(),
	kiosk_hide_menu_update_notification: z.boolean(),
	kiosk_disable_lock_screen: z.boolean(),
	kiosk_bypass_guest_auth: z.boolean(),
	qr_auth_required: z.boolean(),
	kiosk_hide_menu_btn: z.boolean(),
	qr_show_modifiers_in_cart: z.boolean(),
	qr_use_qr_for_payment: z.boolean(),
	qr_repeat_order: z.boolean(),
	kiosk_show_modifiers_in_cart: z.boolean(),
	kiosk_login_loyalty_reminder_in_cart_text: z.string().nullable(),
	kiosk_age_confirmation_enabled: z.boolean(),
	kiosk_age_confirmation_barcode: z.string().nullable(),
	kiosk_age_confirmation_pin: z.string().nullable(),
	kiosk_age_confirmation_warning_text: z.string(),
	cart_promo_code: z.boolean(),
	kiosk_loyalty_plant_scanner: z.boolean(),
	kiosk_loyalty_plant_manual: z.boolean(),
	kiosk_drum: z.string().nullable(),
	kiosk_drum_infinity: z.boolean(),
	kiosk_show_drum_search_button: z.boolean(),
	kiosk_drum_wrf: newKioskDrumWrfSchema,
	kiosk_group_list_style: z.string(),
	kiosk_add_to_cart_text: z.string().nullable(),
	kiosk_payment_tracker_image: z.string().nullable(),
	kiosk_payment_tracker_title: z.string().nullable(),
	kiosk_payment_tracker_description: z.string().nullable(),
	close_time_disclaimer_text: z.string(),
	product_price_prefix: z.boolean(),
	kiosk_marking_confirmation_barcode: z.string().nullable(),
	kiosk_marking_confirmation_pin: z.string().nullable(),
	kiosk_marking_confirmation_warning_text: z.string(),
	table_change_pin_code: z.string().nullable(),
	coffe_house: z.boolean(),
});
